import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Krys, 2022</div>;
}

export default Footer;